import React, { useEffect, useMemo, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";

import { busStudentList } from "../../api/Transport";

import { SweetAlertShow, LoadingDiv } from "../master/Master";

import BusStudentIdCard from "./components/BusStudentIdCard";

import "./components/BusStudentIdCard.css";

import Select from "react-select";
import { imgBaseUrl } from "../../api/api";

const THEME_PRESETS = [
  "#123c73", // blue (current default)
  "#7C2D12", // maroon
  "#065F46", // emerald
  "#92400E", // amber-brown
  "#4C1D95", // violet
  "#111827", // charcoal
  "#B91C1C", // red
];

export default function BusStudentIdCardPage() {
  const [loading, setLoading] = useState(false);

  const [students, setStudents] = useState([]);

  const [selectedStudents, setSelectedStudents] = useState([]);

  const [width, setWidth] = useState("95");
  const [height, setHeight] = useState("65");
  const [unit, setUnit] = useState("mm");

  const [themeColor, setThemeColor] = useState(THEME_PRESETS[0]);

  const getStudents = async () => {
    setLoading(true);

    try {
      const response = await busStudentList("limit=all&status=1");

      if (response?.data?.status) {
        const list = response?.data?.data || [];

        setStudents(list);
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message || "Unable to load bus students.",
        );
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStudents();
  }, []);

  /* =========================================
     SEARCHABLE SELECT OPTIONS
  ========================================= */

  const studentOptions = useMemo(() => {
    return students.map((item) => ({
      value: item.id,
      label: `${item?.student?.name || "Unknown"} (${item?.student?.registration_no || "-"})`,
      student: item,
    }));
  }, [students]);

  /* =========================================
     STUDENT SELECT
  ========================================= */

  const handleStudentChange = (options) => {
    const selected = options || [];

    setSelectedStudents(selected.map((option) => option.student));
  };

  /* =========================================
     REMOVE STUDENT
  ========================================= */

  const removeStudent = (id) => {
    setSelectedStudents((prev) => prev.filter((item) => item.id !== id));
  };

  /* =========================================
     PRINT
  ========================================= */
  const printCards = async () => {
    if (!selectedStudents.length) {
      SweetAlertShow(
        "info",
        "Select Student",
        "Please select at least one student."
      );
      return;
    }

    const printWindow = window.open("", "_blank");

    if (!printWindow) {
      SweetAlertShow(
        "error",
        "Popup Blocked",
        "Please allow popups and try again."
      );
      return;
    }

    const printContent = document.getElementById("BusPrintDiv");

    if (!printContent) {
      printWindow.close();

      SweetAlertShow(
        "error",
        "Error",
        "Print cards not found."
      );

      return;
    }

    // सभी CSS files
    const cssLinks = Array.from(
      document.querySelectorAll('link[rel="stylesheet"]')
    )
      .map((link) => {
        return `<link rel="stylesheet" href="${link.href}" />`;
      })
      .join("\n");

    // सभी style tags
    const styleTags = Array.from(
      document.querySelectorAll("style")
    )
      .map((style) => style.outerHTML)
      .join("\n");

    printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />
        <title>Bus Student ID Cards</title>

        ${cssLinks}

        ${styleTags}

        <style>
          * {
            box-sizing: border-box !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          @page {
            size: ${width}${unit} ${height}${unit};
            margin: 0 !important;
          }

          html,
          body {
            width: ${width}${unit} !important;
            height: ${height}${unit} !important;

            margin: 0 !important;
            padding: 0 !important;

            overflow: hidden !important;
            background: white !important;
          }

          .bus-print-area {
            display: block !important;

            position: static !important;
            left: auto !important;
            top: auto !important;

            width: ${width}${unit} !important;

            margin: 0 !important;
            padding: 0 !important;
          }

          .print-card-wrapper {
            display: block !important;

            width: ${width}${unit} !important;
            height: ${height}${unit} !important;

            margin: 0 !important;
            padding: 0 !important;

            overflow: hidden !important;

            page-break-after: always !important;
            break-after: page !important;
          }

          .print-card-wrapper:last-child {
            page-break-after: auto !important;
            break-after: auto !important;
          }

          .bus-id-card {
            display: block !important;

            width: ${width}${unit} !important;
            height: ${height}${unit} !important;

            margin: 0 !important;
            padding: 0 !important;

            border-radius: 0 !important;
            box-shadow: none !important;

            overflow: hidden !important;

            page-break-inside: avoid !important;
            break-inside: avoid !important;
          }
        </style>
      </head>

      <body>
        <div class="bus-print-area">
          ${printContent.innerHTML}
        </div>
      </body>
    </html>
  `);

    printWindow.document.close();

    // पूरा DOM load होने दो
    await new Promise((resolve) => {
      printWindow.onload = resolve;

      setTimeout(resolve, 1500);
    });

    // Images wait
    const images = Array.from(printWindow.document.images);

    await Promise.all(
      images.map((img) => {
        if (img.complete) {
          return Promise.resolve();
        }

        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      })
    );

    // Fonts wait
    if (printWindow.document.fonts?.ready) {
      await printWindow.document.fonts.ready;
    }

    await new Promise((resolve) => setTimeout(resolve, 800));

    printWindow.focus();
    printWindow.print();
  };
  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid mt-3">

                <div className="card border-0 shadow-sm mb-3">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                      <div>
                        <h4 className="mb-1 text-primary fw-bold">
                          <i className="ri-id-card-line me-2" />
                          Bus Student ID Cards
                        </h4>

                        <div className="text-muted small">
                          Search students, preview their ID cards and print.
                        </div>
                      </div>

                      <button
                        type="button"
                        className="btn btn-primary"
                        disabled={selectedStudents.length === 0}
                        onClick={printCards}
                      >
                        <i className="ri-printer-line me-1" />
                        Print{" "}
                        {selectedStudents.length > 0 &&
                          `(${selectedStudents.length})`}
                      </button>


                    </div>
                  </div>
                </div>


                <div className="card border-0 shadow-sm mb-3">
                  <div className="card-body">
                    <div className="row g-3">
                      {/* SEARCHABLE STUDENT */}

                      <div className="col-lg-6">
                        <label className="form-label fw-semibold">
                          Select Student
                        </label>

                        <Select
                          isMulti
                          isSearchable
                          isClearable
                          closeMenuOnSelect={false}
                          options={studentOptions}
                          value={studentOptions.filter((option) =>
                            selectedStudents.some(
                              (student) => student.id === option.value,
                            ),
                          )}
                          onChange={handleStudentChange}
                          placeholder="Search student name or registration no..."
                          noOptionsMessage={() => "No student found"}
                          formatOptionLabel={(option) => (
                            <div className="d-flex align-items-center gap-2">
                              <div
                                className="rounded-circle overflow-hidden border"
                                style={{
                                  width: 36,
                                  height: 36,
                                  flexShrink: 0,
                                }}
                              >
                                <img
                                  src={
                                    option.student?.student?.profile_picture
                                      ? imgBaseUrl +
                                      option.student.student.profile_picture
                                      : "/files/user.png"
                                  }
                                  alt=""
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>

                              <div>
                                <div className="fw-semibold">
                                  {option.student?.student?.name}
                                </div>

                                <small className="text-muted">
                                  {option.student?.student?.registration_no}

                                  {" • "}

                                  {option.student?.bus?.bus_number}
                                </small>
                              </div>
                            </div>
                          )}
                        />

                        <small className="text-muted">
                          You can select multiple students.
                        </small>
                      </div>

                      {/* WIDTH */}

                      <div className="col-lg-2">
                        <label className="form-label fw-semibold">Width</label>

                        <div className="input-group">
                          <input
                            type="number"
                            min="20"
                            value={width}
                            onChange={(e) => setWidth(e.target.value)}
                            className="form-control"
                          />

                          <span className="input-group-text">{unit}</span>
                        </div>
                      </div>

                      {/* HEIGHT */}

                      <div className="col-lg-2">
                        <label className="form-label fw-semibold">Height</label>

                        <div className="input-group">
                          <input
                            type="number"
                            min="20"
                            value={height}
                            onChange={(e) => setHeight(e.target.value)}
                            className="form-control"
                          />

                          <span className="input-group-text">{unit}</span>
                        </div>
                      </div>

                      {/* UNIT */}

                      <div className="col-lg-2">
                        <label className="form-label fw-semibold">Unit</label>

                        <select
                          className="form-select"
                          value={unit}
                          onChange={(e) => setUnit(e.target.value)}
                        >
                          <option value="mm">MM</option>

                          <option value="cm">CM</option>

                          <option value="in">IN</option>

                          <option value="px">PX</option>
                        </select>
                      </div>

                      {/* THEME COLOR */}

                      <div className="col-lg-12">
                        <label className="form-label fw-semibold">
                          Card Color
                        </label>

                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <input
                            type="color"
                            value={themeColor}
                            onChange={(e) => setThemeColor(e.target.value)}
                            title="Pick any color"
                            style={{
                              width: 42,
                              height: 38,
                              padding: 2,
                              border: "1px solid #dee2e6",
                              borderRadius: 8,
                              cursor: "pointer",
                            }}
                          />

                          {THEME_PRESETS.map((color) => (
                            <button
                              key={color}
                              type="button"
                              onClick={() => setThemeColor(color)}
                              title={color}
                              style={{
                                width: 26,
                                height: 26,
                                borderRadius: "50%",
                                background: color,
                                border:
                                  themeColor === color
                                    ? "2px solid #333"
                                    : "2px solid transparent",
                                boxShadow: "0 0 0 1px #fff, 0 0 0 2px #dee2e6",
                                cursor: "pointer",
                              }}
                            />
                          ))}

                          <span className="text-muted small ms-1">
                            {themeColor}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* =========================================
                    SELECTED STUDENTS
                ========================================= */}

                {selectedStudents.length > 0 && (
                  <div className="card border-0 shadow-sm mb-3">
                    <div className="card-header bg-white">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h6 className="mb-0 fw-bold">Selected Students</h6>

                          <small className="text-muted">
                            {selectedStudents.length} student
                            {selectedStudents.length > 1 ? "s" : ""}
                          </small>
                        </div>
                      </div>
                    </div>

                    <div className="card-body">
                      <div className="d-flex flex-wrap gap-2">
                        {selectedStudents.map((student) => (
                          <div
                            key={student.id}
                            className="badge bg-label-primary d-flex align-items-center gap-2 p-2"
                          >
                            <span>{student?.student?.name}</span>

                            <button
                              type="button"
                              className="btn btn-sm p-0 text-danger"
                              onClick={() => removeStudent(student.id)}
                            >
                              <i className="ri-close-line" />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* =========================================
                    PREVIEW
                ========================================= */}

                <div className="card border-0 shadow-sm">
                  <div className="card-header bg-white">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="mb-0 fw-bold">
                          <i className="ri-eye-line me-1" />
                          ID Card Preview
                        </h6>

                        <small className="text-muted">
                          {width}
                          {unit} × {height}
                          {unit}
                        </small>
                      </div>

                      {selectedStudents.length > 0 && (
                        <span className="badge bg-label-success">
                          {selectedStudents.length} Card
                          {selectedStudents.length > 1 ? "s" : ""}
                        </span>
                      )}
                    </div>
                  </div>

                  <div
                    className="card-body"
                    style={{
                      background: "#f3f5f8",
                      minHeight: 400,
                    }}
                  >
                    {selectedStudents.length === 0 ? (
                      <div
                        className="d-flex flex-column align-items-center justify-content-center text-muted"
                        style={{
                          minHeight: 350,
                        }}
                      >
                        <i
                          className="ri-id-card-line"
                          style={{
                            fontSize: 60,
                            opacity: 0.25,
                          }}
                        />

                        <h6 className="mt-3">Select a student</h6>

                        <p className="mb-0">
                          Search and select a student above to preview the ID
                          card.
                        </p>
                      </div>
                    ) : (
                      <div className="d-flex flex-wrap justify-content-center align-items-start gap-4">
                        {selectedStudents.map((student) => (
                          <div
                            key={student.id}
                            className="bg-white p-3 rounded-3 shadow-sm"
                          >
                            <BusStudentIdCard
                              data={student}
                              themeColor={themeColor}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>


                <div
                  id="BusPrintDiv"
                  className="bus-print-area"
                  style={{
                    position: "fixed",
                    left: "-10000px",
                    top: "0",
                    pointerEvents: "none",
                  }}
                >
                  {selectedStudents.map((student) => (
                    <div
                      key={student.id}
                      className="print-card-wrapper"
                      style={{
                        width: `${width}${unit}`,
                        height: `${height}${unit}`,
                      }}
                    >
                      <BusStudentIdCard
                        data={student}
                        themeColor={themeColor}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
